import { render, staticRenderFns } from "./PlayIcon.vue?vue&type=template&id=7c3b4b35&scoped=true&"
import script from "./PlayIcon.vue?vue&type=script&lang=js&"
export * from "./PlayIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlayIcon.vue?vue&type=style&index=0&id=7c3b4b35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b4b35",
  null
  
)

export default component.exports